// extracted by mini-css-extract-plugin
module.exports = {"main":"Dashboard_main__19n8Y"};